import { render, staticRenderFns } from "./AuxiliaryHeader.vue?vue&type=template&id=832510da&scoped=true&"
import script from "./AuxiliaryHeader.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryHeader.vue?vue&type=style&index=0&id=832510da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832510da",
  null
  
)

export default component.exports